import { takeLatest, put, call } from 'redux-saga/effects';

import { listFuncionarioCadastro } from '../service';
import {
  TABLE_FUNCIONARIO_CADASTRO,
  TABLE_FUNCIONARIO_CADASTRO_PENDING,
  TABLE_FUNCIONARIO_CADASTRO_SUCCESS,
  TABLE_FUNCIONARIO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListFuncionarioCadastro(action) {
  yield put({ type: TABLE_FUNCIONARIO_CADASTRO_PENDING })

  try {
    const table = yield call(listFuncionarioCadastro, action.args)
    yield put({ type: TABLE_FUNCIONARIO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_FUNCIONARIO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListFuncionarioCadastro() {
  yield takeLatest(TABLE_FUNCIONARIO_CADASTRO, sagaListFuncionarioCadastro)
}